import { RTC_PROVIDERS } from '../../../providerIds'
import { createZoomRtcPortBundle } from './createZoomRtcPortBundle'
import {
  createZoomRtcAdapterCapabilities,
  createZoomRtcCompatibilityProps,
  preloadZoomRtcModule,
  ZoomRtcCompatibilitySurface,
} from './zoomRtcCompat'
import { createZoomRtcSessionHandle } from './createZoomRtcSessionHandle'

export { ZOOM_RTC_SESSION_EVENTS } from './createZoomRtcSessionHandle'
export { createZoomRtcSessionHandle } from './createZoomRtcSessionHandle'

export function createZoomRtcAdapter({ capabilityOverrides = {} } = {}) {
  return {
    id: RTC_PROVIDERS.zoomVideoSdk,
    domain: 'rtc',
    compatibilityBridge: 'zoom-video-sdk',
    supports: createZoomRtcAdapterCapabilities(capabilityOverrides),
    preload: preloadZoomRtcModule,
    CompatibilitySurface: ZoomRtcCompatibilitySurface,
    createCompatibilityProps: createZoomRtcCompatibilityProps,
    createSession(initialConfig = {}) {
      return createZoomRtcSessionHandle({
        initialConfig,
      })
    },
    createPortBundle(options = {}) {
      return createZoomRtcPortBundle(options)
    },
  }
}

export const zoomRtcAdapter = createZoomRtcAdapter()
